<template>
    <l-chart
        :options="chartOptions"
        :colors="['grey', 'green']"
        :data="{
            labels: [data.map(x => x.t)],
            datasets: [
                {
                    label: 'Projection',
                    data: generateProjection,
                    maxBarThickness: 12,
                    borderDash: [10, 5],
                    fill: false,
                },
                {
                    label: 'Real',
                    data,
                    tension: 0,
                    maxBarThickness: 12,
                },
            ],
        }"
        type="line"
        height="300"
    />
</template>

<script>
import LChart from "@/components/LChart";

export default {
    components: {
        LChart,
    },
    props: {
        range: {
            type: Object,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        start() {
            return this.$moment(this.range.start);
        },
        end() {
            return this.$moment(this.range.end);
        },
        durationInMinutes() {
            return this.end.diff(this.start, "minutes");
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                fullWidth: true,
                title: {
                    display: false,
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    displayColors: true,
                    callbacks: {
                        title: context => {
                            if (context && context.length) {
                                return new Date(context[0].xLabel).toDateString();
                            }
                            return "Unknown";
                        },
                        label: context => {
                            const duration = this.$moment(context.label).diff(
                                this.start,
                                "minutes",
                            );
                            if (context.datasetIndex === 0) {
                                // datasetIndex === 0, its the projection line.
                                return `${this.$t(
                                    `goals.update.labelProjectedProgress`,
                                )} ${context.value || ""}`;
                            } else {
                                return [
                                    `${this.$t(`goals.update.labelRealProgress`)} ${context.value ||
                                        ""}`,
                                    `${this.$t(`goals.update.labelProjectedProgress`)} ${(
                                        (duration / this.durationInMinutes) *
                                        100
                                    ).toFixed(2)}`,
                                ];
                            }
                        },
                        mode: "dataset",
                    },
                },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                unit: "day",
                            },
                            ticks: {
                                fontColor: "#9CA3AF",
                                fontSize: 10,
                                source: "auto",
                                autoSkip: true,
                                maxTicksLimit: 5,
                                min: this.$moment(this.range.start).subtract(6, "hours"),
                                max: this.$moment(this.range.end).add(6, "hours"),
                            },
                            gridLines: {
                                display: false,
                                color: "#F9FAFB",
                            },
                        },
                    ],
                    yAxes: [
                        {
                            offset: true,
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                fontSize: 10,
                                fontColor: "#9CA3AF",
                                autoSkip: true,
                                maxTicksLimit: 6,
                            },
                            gridLines: {
                                color: "#F9FAFB",
                            },
                        },
                    ],
                },
            };
        },

        generateProjection() {
            return [
                { t: this.start.toDate().toISOString(), y: 0 },
                {
                    t: this.start
                        .clone()
                        .add(this.durationInMinutes / 4, "minutes")
                        .toDate()
                        .toISOString(),
                    y: 25,
                },
                {
                    t: this.start
                        .clone()
                        .add((this.durationInMinutes / 4) * 2, "minutes")
                        .toDate()
                        .toISOString(),
                    y: 50,
                },
                {
                    t: this.start
                        .clone()
                        .add((this.durationInMinutes / 4) * 3, "minutes")
                        .toDate()
                        .toISOString(),
                    y: 75,
                },
                {
                    t: this.end.toDate().toISOString(),
                    y: 100,
                },
            ];
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>

<style scoped></style>
